import React, { useEffect, useState } from "react";

import { AlignVAT } from "@vp/ep-pricing";
import { upperFunnelPages } from "../../constants/pageId";
import { useProductStore } from "../../store/productPriceDetails.store";
import { PageId } from "../../types/pageId";
import { DisplayVariant, PriceDisplayType, SelectionsWithQuantity } from "../../types/pricing/price-display.types";
import { PriceDisplayV2, PriceDisplayV2Props } from "../PriceDisplayV2/PriceDisplayV2";
import { PriceDisplayProps } from "./PriceDisplay";

const sanitizeSelections = (
  selections?: SelectionsWithQuantity,
  fallbackQuantity?: number,
): SelectionsWithQuantity | undefined => {
  const resolvedQuantity =
    selections?.quantity ??
    selections?.Quantity ??
    fallbackQuantity;

  const { quantity: _q1, Quantity: _q2, ...rest } =
    selections ?? {};

  const filteredQuantities = String(resolvedQuantity)
  .split(",")
  .map(q => q.trim())
  .filter(q => Number(q) > 0);

  return filteredQuantities.length > 0
    ? { ...rest, quantity: filteredQuantities.join(",") }
    : rest;
};

const PriceDisplayTransitionWrapper = (props: PriceDisplayProps) => {
  const basePriceExtractionConfig = useProductStore((state) => state.basePriceExtractionConfig);
  const [pageId, setPageId] = useState<PageId | undefined>(basePriceExtractionConfig?.pageId);

  useEffect(() => {
    if (pageId) return;
    if (basePriceExtractionConfig?.pageId) {
      setPageId(basePriceExtractionConfig.pageId);
    }
  }, [basePriceExtractionConfig?.pageId, pageId]);

  //todo: remove this once all pages migrate to new pricing component
  const effectivePageId = pageId ?? basePriceExtractionConfig?.pageId;

  const priceDisplayProps: PriceDisplayV2Props = {
    mpvId: props.mpvId,
    productId: props.productId ?? props.productKey,
    version: props.version,
    selections: sanitizeSelections(props.selections, props.quantity) as SelectionsWithQuantity | undefined,
    alternateSelections: sanitizeSelections(props.alternateSelections),
    hideMinimumOrderableQuantity: props.hideMinimumOrderableQuantity,
    requestedPriceDisplayStrategy: (props.requestedPriceDisplayStrategy ?? props.priceDisplayStrategy) as PriceDisplayType | undefined,
    developmentMode: props.developmentMode,
    displayVariant: props.displayVariant ?? (effectivePageId && upperFunnelPages.includes(effectivePageId) ? DisplayVariant.FROM : undefined),
    alignVAT: props.alignVAT || (effectivePageId === PageId.PDC ? AlignVAT.RIGHT : AlignVAT.BOTTOM),
    isTile: props.isTile ?? (effectivePageId ? upperFunnelPages.includes(effectivePageId) : false),
    alwaysShowMOQInfo: props.alwaysShowMOQInfo,
  };

  return <PriceDisplayV2 {...priceDisplayProps} />;
};

export default PriceDisplayTransitionWrapper;
